export function getLastTab(key) {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export function setLastTab(key, value) {
  try {
    localStorage.setItem(key, value)
  } catch {
    // localStorage unavailable (private mode, quota exceeded) — not critical
  }
}

export function resolveTargetTabId(list, lastTabId) {
  return list.find((item) => item.id === lastTabId) ? lastTabId : list[0].id
}
